<template>
  <v-container class="max-width-1200">
    <v-row>
      <v-col class="pb-0 headline text-uppercase">
        {{ $t('common.studies') }}
      </v-col>
    </v-row>
    <v-row>
      <v-col class="display-1">
        {{ $t('common.learnAboutOurWork')}}
      </v-col>
    </v-row>

    <v-row class="text-center justify-center">
      <v-col
        cols="12" sm="12" md="4" lg="3">
        <v-hover
          v-slot="{ hover }">
          <v-card
            flat
            @click="showStudy(item, 'studyText')">
            <v-img
              height="300px"
              src="@/assets/img/em-energymonitor-studies-01.webp">
              <v-expand-transition>
                <div
                  v-if="hover"
                  class="d-flex transition-fast-in-fast-out primary darken-2 overlay-hover display-3 white--text"
                  style="height: 100%;">
                    {{ $t("common.readMore") }}
                </div>
              </v-expand-transition>
              <v-row class="white--text fill-height align-end overlay">
                <v-icon
                  v-if="panel == 0"
                  dark
                  class="icon-tile-mark">
                  mdi-bookmark
                </v-icon>
                <v-col cols="12" class="px-8 title text-start">
                  <!-- {{ item.title }} -->
                </v-col>
                <v-col v-if="!hover" cols="12" class="px-8 text-start">
                  <span class="title">{{ $t("study.rubicon.title") }}</span><br>
                  <span class="overline">{{ $t("common.readMore") }}</span>
                </v-col>
              </v-row>
            </v-img>
          </v-card>
        </v-hover>
      </v-col>
      <v-col
        cols="12" sm="12" md="8" lg="9"
        class="text-justify">
        <p class="px-3">
          {{ $t("study.rubicon.abstarct") }}
        </p>
        <v-btn
          v-if="panel != 0"
          class="mx-3"
          color="primary"
          depressed tile
          @click="panel = 0">
          {{ $t("common.readMore") }}
        </v-btn>

        <v-row id="studyText" class="min-height-300">
          <v-expansion-panels
            v-model="panel"
            accordion
            flat>
            <v-expansion-panel>
              <v-expansion-panel-content>
                <Case></Case>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-col>
    </v-row>


    <!-- partners -->
    <v-row class="py-8 text-left justify-center">
      <v-col style="display:contents;">
        <div
          v-for="(item,index) in partners"
          :key="index"
          class="ma-4">
            <img
              :src="item.img"
              loading="lazy"
              :alt="item.name + 'logó'"
              height="30" :width="item.width"
              style="object-fit:contain;">
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';
  import Case from '@/components/Studies/Rubicon-biatorbagy';

  export default {
    name: 'RubiconStudies',
    extends: DataComponentBase,

    components: {
      Case,
    },

    data: () => ({

      panel: null,
      partners: [
        { img: require("@/assets/partners/partner_antennahungaria.png"),     name: "Antenna Hungária",    width: '86'  },
        { img: require("@/assets/partners/partner_magyartelekom.png"),       name: "Magyar Telekom",      width: '128'  },
      ],

    }),

    computed: {
    },

    methods: {
      showStudy(panel, id) {
        this.panel = panel;
        this.scrollTOSection(id);
      },
      scrollTOSection(id) {
        var section = document.getElementById(id);
        section.scrollIntoView();
      },
    },
  }
</script>
